

export const hoverStyle1: any =
    [
        { "value": " ", "name": "none" },
        { "value": "hvr-grow", "name": "Grow" },
        { "value": "hvr-shrink", "name": "Shrink" },
        { "value": "hvr-pulse", "name": "Pulse" },
        { "value": "hvr-pulse-grow", "name": "Pulse Grow" },
        { "value": "hvr-pulse-shrink", "name": "Pulse Shrink" },
        { "value": "hvr-push", "name": "Push" },
        { "value": "hvr-pop", "name": "Pop" },
        { "value": "hvr-bounce-in", "name": "Bounce In" },
        { "value": "hvr-bounce-out", "name": "Bounce Out" },
        { "value": "hvr-rotate", "name": "Rotate" },
        { "value": "hvr-grow-rotate", "name": "Grow Rotate" },
        { "value": "hvr-float", "name": "Float" },
        { "value": "hvr-sink", "name": "Sink" },
        { "value": "hvr-bob", "name": "Bob" },
        { "value": "hvr-hang", "name": "Hang" },
        { "value": "hvr-skew", "name": "Skew" },
        { "value": "hvr-skew-forward", "name": "Skew Forward" },
        { "value": "hvr-skew-backward", "name": "Skew Backward" },
        { "value": "hvr-wobble-horizontal", "name": "Wobble Horizontal" },
        { "value": "hvr-wobble-vertical", "name": "Wobble Vertical" },
        { "value": "hvr-wobble-to-bottom-right", "name": "Wobble To Bottom Right" },
        { "value": "hvr-wobble-to-top-right", "name": "Wobble To Top Right" },
        { "value": "hvr-wobble-top", "name": "Wobble Top" },
        { "value": "hvr-wobble-bottom", "name": "Wobble Bottom" },
        { "value": "hvr-wobble-skew", "name": "Wobble Skew" },
        { "value": "hvr-buzz", "name": "Buzz" },
        { "value": "hvr-buzz-out", "name": "Buzz Out" },
        { "value": "hvr-forward", "name": "Forward" },
        { "value": "hvr-backward", "name": "Backward" },

    ];

export const hoverStyle2: any =
    [
        { "value": "hvr-shadow", "name": "Shadow" },
        { "value": "hvr-grow-shadow", "name": "Grow Shadow" },
        { "value": "hvr-float-shadow", "name": "Float Shadow" },
        { "value": "hvr-glow", "name": "Glow" },
        { "value": "hvr-shadow-radial", "name": "Shadow Radial" },
        { "value": "hvr-box-shadow-outset", "name": "Box Shadow Outset" },
        { "value": "hvr-box-shadow-inset", "name": "Box Shadow Inset" },
    ]
export const hoverStyle3: any = [
    { "value": "hvr-curl-top-left", "name": "Curl Top Left" },
    { "value": "hvr-curl-top-right", "name": "Curl Top Right" },
    { "value": "hvr-curl-bottom-right", "name": "Curl Bottom Right" },
    { "value": "hvr-curl-bottom-left", "name": "Curl Bottom Left" }
]
export const icons: any = [
    { "value": "fab fa-instagram" },
    { "value": "fab fa-youtube" },
    { "value": "fab fa-linkedin-in" },
    { "value": "fab fa-facebook-f" },
    { "value": "fab fa-twitter" },
    { "value": "fas fa-ad" },
    { "value": "fas fa-address-book" },
    { "value": "fas fa-address-card" },
    { "value": "fas fa-adjust" },
    { "value": "fas fa-air-freshener" },
    { "value": "fas fa-align-center" },
    { "value": "fas fa-align-justify" },
    { "value": "fas fa-align-left" },
    { "value": "fas fa-align-right" },
    { "value": "fas fa-allergies" },
    { "value": "fas fa-ambulance" },
    { "value": "fas fa-american-sign-language-interpreting" },
    { "value": "fas fa-anchor" },
    { "value": "fas fa-angle-double-down" },
    { "value": "fas fa-angle-double-left" },
    { "value": "fas fa-angle-double-right" },
    { "value": "fas fa-angle-double-up" },
    { "value": "fas fa-angle-down" },
    { "value": "fas fa-angle-left" },
    { "value": "fas fa-angle-right" },
    { "value": "fas fa-angle-up" },
    { "value": "fas fa-angry" },
    { "value": "fas fa-ankh" },
    { "value": "fas fa-apple-alt" },
    { "value": "fas fa-archive" },
    { "value": "fas fa-archway" },
    { "value": "fas fa-arrow-alt-circle-down" },
    { "value": "fas fa-arrow-alt-circle-left" },
    { "value": "fas fa-arrow-alt-circle-right" },
    { "value": "fas fa-arrow-alt-circle-up" },
    { "value": "fas fa-arrow-circle-down" },
    { "value": "fas fa-arrow-circle-left" },
    { "value": "fas fa-arrow-circle-right" },
    { "value": "fas fa-arrow-circle-up" },
    { "value": "fas fa-arrow-down" },
    { "value": "fas fa-arrow-left" },
    { "value": "fas fa-arrow-right" },
    { "value": "fas fa-arrow-up" },
    { "value": "fas fa-arrows-alt-h" },
    { "value": "fas fa-arrows-alt-v" },
    { "value": "fas fa-arrows-alt" },
    { "value": "fas fa-assistive-listening-systems" },
    { "value": "fas fa-asterisk" },
    { "value": "fas fa-at" },
    { "value": "fas fa-atlas" },
    { "value": "fas fa-atom" },
    { "value": "fas fa-audio-description" },
    { "value": "fas fa-award" },
    { "value": "fas fa-baby-carriage" },
    { "value": "fas fa-baby" },
    { "value": "fas fa-backspace" },
    { "value": "fas fa-backward" },
    { "value": "fas fa-bacon" },
    { "value": "fas fa-balance-scale-left" },
    { "value": "fas fa-balance-scale-right" },
    { "value": "fas fa-balance-scale" },
    { "value": "fas fa-ban" },
    { "value": "fas fa-band-aid" },
    { "value": "fas fa-barcode" },
    { "value": "fas fa-bars" },
    { "value": "fas fa-baseball-ball" },
    { "value": "fas fa-basketball-ball" },
    { "value": "fas fa-bath" },
    { "value": "fas fa-battery-empty" },
    { "value": "fas fa-battery-full" },
    { "value": "fas fa-battery-half" },
    { "value": "fas fa-battery-quarter" },
    { "value": "fas fa-battery-three-quarters" },
    { "value": "fas fa-bed" },
    { "value": "fas fa-beer" },
    { "value": "fas fa-bell-slash" },
    { "value": "fas fa-bell" },
    { "value": "fas fa-bezier-curve" },
    { "value": "fas fa-bible" },
    { "value": "fas fa-bicycle" },
    { "value": "fas fa-biking" },
    { "value": "fas fa-binoculars" },
    { "value": "fas fa-biohazard" },
    { "value": "fas fa-birthday-cake" },
    { "value": "fas fa-blender-phone" },
    { "value": "fas fa-blender" },
    { "value": "fas fa-blind" },
    { "value": "fas fa-blog" },
    { "value": "fas fa-bold" },
    { "value": "fas fa-bolt" },
    { "value": "fas fa-bomb" },
    { "value": "fas fa-bone" },
    { "value": "fas fa-bong" },
    { "value": "fas fa-book-dead" },
    { "value": "fas fa-book-medical" },
    { "value": "fas fa-book-open" },
    { "value": "fas fa-book-reader" },
    { "value": "fas fa-book" },
    { "value": "fas fa-bookmark" },
    { "value": "fas fa-border-all" },
    { "value": "fas fa-border-none" },
    { "value": "fas fa-border-style" },
    { "value": "fas fa-bowling-ball" },
    { "value": "fas fa-box-open" },
    { "value": "fas fa-box" },
    { "value": "fas fa-boxes" },
    { "value": "fas fa-braille" },
    { "value": "fas fa-brain" },
    { "value": "fas fa-bread-slice" },
    { "value": "fas fa-briefcase-medical" },
    { "value": "fas fa-briefcase" },
    { "value": "fas fa-broadcast-tower" },
    { "value": "fas fa-broom" },
    { "value": "fas fa-brush" },
    { "value": "fas fa-bug" },
    { "value": "fas fa-building" },
    { "value": "fas fa-bullhorn" },
    { "value": "fas fa-bullseye" },
    { "value": "fas fa-burn" },
    { "value": "fas fa-bus-alt" },
    { "value": "fas fa-bus" },
    { "value": "fas fa-business-time" },
    { "value": "fas fa-calculator" },
    { "value": "fas fa-calendar-alt" },
    { "value": "fas fa-calendar-check" },
    { "value": "fas fa-calendar-day" },
    { "value": "fas fa-calendar-minus" },
    { "value": "fas fa-calendar-plus" },
    { "value": "fas fa-calendar-times" },
    { "value": "fas fa-calendar-week" },
    { "value": "fas fa-calendar" },
    { "value": "fas fa-camera-retro" },
    { "value": "fas fa-camera" },
    { "value": "fas fa-campground" },
    { "value": "fas fa-candy-cane" },
    { "value": "fas fa-cannabis" },
    { "value": "fas fa-capsules" },
    { "value": "fas fa-car-alt" },
    { "value": "fas fa-car-battery" },
    { "value": "fas fa-car-crash" },
    { "value": "fas fa-car-side" },
    { "value": "fas fa-car" },
    { "value": "fas fa-caret-down" },
    { "value": "fas fa-caret-left" },
    { "value": "fas fa-caret-right" },
    { "value": "fas fa-caret-square-down" },
    { "value": "fas fa-caret-square-left" },
    { "value": "fas fa-caret-square-right" },
    { "value": "fas fa-caret-square-up" },
    { "value": "fas fa-caret-up" },
    { "value": "fas fa-carrot" },
    { "value": "fas fa-cart-arrow-down" },
    { "value": "fas fa-cart-plus" },
    { "value": "fas fa-cash-register" },
    { "value": "fas fa-cat" },
    { "value": "fas fa-certificate" },
    { "value": "fas fa-chair" },
    { "value": "fas fa-chalkboard-teacher" },
    { "value": "fas fa-chalkboard" },
    { "value": "fas fa-charging-station" },
    { "value": "fas fa-chart-area" },
    { "value": "fas fa-chart-bar" },
    { "value": "fas fa-chart-line" },
    { "value": "fas fa-chart-pie" },
    { "value": "fas fa-check-circle" },
    { "value": "fas fa-check-double" },
    { "value": "fas fa-check-square" },
    { "value": "fas fa-check" },
    { "value": "fas fa-cheese" },
    { "value": "fas fa-chess-bishop" },
    { "value": "fas fa-chess-board" },
    { "value": "fas fa-chess-king" },
    { "value": "fas fa-chess-knight" },
    { "value": "fas fa-chess-pawn" },
    { "value": "fas fa-chess-queen" },
    { "value": "fas fa-chess-rook" },
    { "value": "fas fa-chess" },
    { "value": "fas fa-chevron-circle-down" },
    { "value": "fas fa-chevron-circle-left" },
    { "value": "fas fa-chevron-circle-right" },
    { "value": "fas fa-chevron-circle-up" },
    { "value": "fas fa-chevron-down" },
    { "value": "fas fa-chevron-left" },
    { "value": "fas fa-chevron-right" },
    { "value": "fas fa-chevron-up" },
    { "value": "fas fa-child" },
    { "value": "fas fa-church" },
    { "value": "fas fa-circle-notch" },
    { "value": "fas fa-circle" },
    { "value": "fas fa-city" },
    { "value": "fas fa-clinic-medical" },
    { "value": "fas fa-clipboard-check" },
    { "value": "fas fa-clipboard-list" },
    { "value": "fas fa-clipboard" },
    { "value": "fas fa-clock" },
    { "value": "fas fa-clone" },
    { "value": "fas fa-closed-captioning" },
    { "value": "fas fa-cloud-download-alt" },
    { "value": "fas fa-cloud-meatball" },
    { "value": "fas fa-cloud-moon-rain" },
    { "value": "fas fa-cloud-moon" },
    { "value": "fas fa-cloud-rain" },
    { "value": "fas fa-cloud-showers-heavy" },
    { "value": "fas fa-cloud-sun-rain" },
    { "value": "fas fa-cloud-sun" },
    { "value": "fas fa-cloud-upload-alt" },
    { "value": "fas fa-cloud" },
    { "value": "fas fa-cocktail" },
    { "value": "fas fa-code-branch" },
    { "value": "fas fa-code" },
    { "value": "fas fa-coffee" },
    { "value": "fas fa-cog" },
    { "value": "fas fa-cogs" },
    { "value": "fas fa-coins" },
    { "value": "fas fa-columns" },
    { "value": "fas fa-comment-alt" },
    { "value": "fas fa-comment-dollar" },
    { "value": "fas fa-comment-dots" },
    { "value": "fas fa-comment-medical" },
    { "value": "fas fa-comment-slash" },
    { "value": "fas fa-comment" },
    { "value": "fas fa-comments-dollar" },
    { "value": "fas fa-comments" },
    { "value": "fas fa-compact-disc" },
    { "value": "fas fa-compass" },
    { "value": "fas fa-compress-arrows-alt" },
    { "value": "fas fa-compress" },
    { "value": "fas fa-concierge-bell" },
    { "value": "fas fa-cookie-bite" },
    { "value": "fas fa-cookie" },
    { "value": "fas fa-copy" },
    { "value": "fas fa-copyright" },
    { "value": "fas fa-couch" },
    { "value": "fas fa-credit-card" },
    { "value": "fas fa-crop-alt" },
    { "value": "fas fa-crop" },
    { "value": "fas fa-cross" },
    { "value": "fas fa-crosshairs" },
    { "value": "fas fa-crow" },
    { "value": "fas fa-crown" },
    { "value": "fas fa-crutch" },
    { "value": "fas fa-cube" },
    { "value": "fas fa-cubes" },
    { "value": "fas fa-cut" },
    { "value": "fas fa-database" },
    { "value": "fas fa-deaf" },
    { "value": "fas fa-democrat" },
    { "value": "fas fa-desktop" },
    { "value": "fas fa-dharmachakra" },
    { "value": "fas fa-diagnoses" },
    { "value": "fas fa-dice-d20" },
    { "value": "fas fa-dice-d6" },
    { "value": "fas fa-dice-five" },
    { "value": "fas fa-dice-four" },
    { "value": "fas fa-dice-one" },
    { "value": "fas fa-dice-six" },
    { "value": "fas fa-dice-three" },
    { "value": "fas fa-dice-two" },
    { "value": "fas fa-dice" },
    { "value": "fas fa-digital-tachograph" },
    { "value": "fas fa-directions" },
    { "value": "fas fa-divide" },
    { "value": "fas fa-dizzy" },
    { "value": "fas fa-dna" },
    { "value": "fas fa-dog" },
    { "value": "fas fa-dollar-sign" },
    { "value": "fas fa-dolly-flatbed" },
    { "value": "fas fa-dolly" },
    { "value": "fas fa-donate" },
    { "value": "fas fa-door-closed" },
    { "value": "fas fa-door-open" },
    { "value": "fas fa-dot-circle" },
    { "value": "fas fa-dove" },
    { "value": "fas fa-download" },
    { "value": "fas fa-drafting-compass" },
    { "value": "fas fa-dragon" },
    { "value": "fas fa-draw-polygon" },
    { "value": "fas fa-drum-steelpan" },
    { "value": "fas fa-drum" },
    { "value": "fas fa-drumstick-bite" },
    { "value": "fas fa-dumbbell" },
    { "value": "fas fa-dumpster-fire" },
    { "value": "fas fa-dumpster" },
    { "value": "fas fa-dungeon" },
    { "value": "fas fa-edit" },
    { "value": "fas fa-egg" },
    { "value": "fas fa-eject" },
    { "value": "fas fa-ellipsis-h" },
    { "value": "fas fa-ellipsis-v" },
    { "value": "fas fa-envelope-open-text" },
    { "value": "fas fa-envelope-open" },
    { "value": "fas fa-envelope-square" },
    { "value": "fas fa-envelope" },
    { "value": "fas fa-equals" },
    { "value": "fas fa-eraser" },
    { "value": "fas fa-ethernet" },
    { "value": "fas fa-euro-sign" },
    { "value": "fas fa-exchange-alt" },
    { "value": "fas fa-exclamation-circle" },
    { "value": "fas fa-exclamation-triangle" },
    { "value": "fas fa-exclamation" },
    { "value": "fas fa-expand-arrows-alt" },
    { "value": "fas fa-expand" },
    { "value": "fas fa-external-link-alt" },
    { "value": "fas fa-external-link-square-alt" },
    { "value": "fas fa-eye-dropper" },
    { "value": "fas fa-eye-slash" },
    { "value": "fas fa-eye" },
    { "value": "fas fa-fan" },
    { "value": "fas fa-fast-backward" },
    { "value": "fas fa-fast-forward" },
    { "value": "fas fa-fax" },
    { "value": "fas fa-feather-alt" },
    { "value": "fas fa-feather" },
    { "value": "fas fa-female" },
    { "value": "fas fa-fighter-jet" },
    { "value": "fas fa-file-alt" },
    { "value": "fas fa-file-archive" },
    { "value": "fas fa-file-audio" },
    { "value": "fas fa-file-code" },
    { "value": "fas fa-file-contract" },
    { "value": "fas fa-file-csv" },
    { "value": "fas fa-file-download" },
    { "value": "fas fa-file-excel" },
    { "value": "fas fa-file-export" },
    { "value": "fas fa-file-image" },
    { "value": "fas fa-file-import" },
    { "value": "fas fa-file-invoice-dollar" },
    { "value": "fas fa-file-invoice" },
    { "value": "fas fa-file-medical-alt" },
    { "value": "fas fa-file-medical" },
    { "value": "fas fa-file-pdf" },
    { "value": "fas fa-file-powerpoint" },
    { "value": "fas fa-file-prescription" },
    { "value": "fas fa-file-signature" },
    { "value": "fas fa-file-upload" },
    { "value": "fas fa-file-video" },
    { "value": "fas fa-file-word" },
    { "value": "fas fa-file" },
    { "value": "fas fa-fill-drip" },
    { "value": "fas fa-fill" },
    { "value": "fas fa-film" },
    { "value": "fas fa-filter" },
    { "value": "fas fa-fingerprint" },
    { "value": "fas fa-fire-alt" },
    { "value": "fas fa-fire-extinguisher" },
    { "value": "fas fa-fire" },
    { "value": "fas fa-first-aid" },
    { "value": "fas fa-fish" },
    { "value": "fas fa-fist-raised" },
    { "value": "fas fa-flag-checkered" },
    { "value": "fas fa-flag-usa" },
    { "value": "fas fa-flag" },
    { "value": "fas fa-flask" },
    { "value": "fas fa-flushed" },
    { "value": "fas fa-folder-minus" },
    { "value": "fas fa-folder-open" },
    { "value": "fas fa-folder-plus" },
    { "value": "fas fa-folder" },
    { "value": "fas fa-font-awesome-logo-full" },
    { "value": "fas fa-font" },
    { "value": "fas fa-football-ball" },
    { "value": "fas fa-forward" },
    { "value": "fas fa-frog" },
    { "value": "fas fa-frown-open" },
    { "value": "fas fa-frown" },
    { "value": "fas fa-funnel-dollar" },
    { "value": "fas fa-futbol" },
    { "value": "fas fa-gamepad" },
    { "value": "fas fa-gas-pump" },
    { "value": "fas fa-gavel" },
    { "value": "fas fa-gem" },
    { "value": "fas fa-genderless" },
    { "value": "fas fa-ghost" },
    { "value": "fas fa-gift" },
    { "value": "fas fa-gifts" },
    { "value": "fas fa-glass-cheers" },
    { "value": "fas fa-glass-martini-alt" },
    { "value": "fas fa-glass-martini" },
    { "value": "fas fa-glass-whiskey" },
    { "value": "fas fa-glasses" },
    { "value": "fas fa-globe-africa" },
    { "value": "fas fa-globe-americas" },
    { "value": "fas fa-globe-asia" },
    { "value": "fas fa-globe-europe" },
    { "value": "fas fa-globe" },
    { "value": "fas fa-golf-ball" },
    { "value": "fas fa-gopuram" },
    { "value": "fas fa-graduation-cap" },
    { "value": "fas fa-greater-than-equal" },
    { "value": "fas fa-greater-than" },
    { "value": "fas fa-grimace" },
    { "value": "fas fa-grin-alt" },
    { "value": "fas fa-grin-beam-sweat" },
    { "value": "fas fa-grin-beam" },
    { "value": "fas fa-grin-hearts" },
    { "value": "fas fa-grin-squint-tears" },
    { "value": "fas fa-grin-squint" },
    { "value": "fas fa-grin-stars" },
    { "value": "fas fa-grin-tears" },
    { "value": "fas fa-grin-tongue-squint" },
    { "value": "fas fa-grin-tongue-wink" },
    { "value": "fas fa-grin-tongue" },
    { "value": "fas fa-grin-wink" },
    { "value": "fas fa-grin" },
    { "value": "fas fa-grip-horizontal" },
    { "value": "fas fa-grip-lines-vertical" },
    { "value": "fas fa-grip-lines" },
    { "value": "fas fa-grip-vertical" },
    { "value": "fas fa-guitar" },
    { "value": "fas fa-h-square" },
    { "value": "fas fa-hamburger" },
    { "value": "fas fa-hammer" },
    { "value": "fas fa-hamsa" },
    { "value": "fas fa-hand-holding-heart" },
    { "value": "fas fa-hand-holding-usd" },
    { "value": "fas fa-hand-holding" },
    { "value": "fas fa-hand-lizard" },
    { "value": "fas fa-hand-middle-finger" },
    { "value": "fas fa-hand-paper" },
    { "value": "fas fa-hand-peace" },
    { "value": "fas fa-hand-point-down" },
    { "value": "fas fa-hand-point-left" },
    { "value": "fas fa-hand-point-right" },
    { "value": "fas fa-hand-point-up" },
    { "value": "fas fa-hand-pointer" },
    { "value": "fas fa-hand-rock" },
    { "value": "fas fa-hand-scissors" },
    { "value": "fas fa-hand-spock" },
    { "value": "fas fa-hands-helping" },
    { "value": "fas fa-hands" },
    { "value": "fas fa-handshake" },
    { "value": "fas fa-hanukiah" },
    { "value": "fas fa-hard-hat" },
    { "value": "fas fa-hashtag" },
    { "value": "fas fa-hat-wizard" },
    { "value": "fas fa-haykal" },
    { "value": "fas fa-hdd" },
    { "value": "fas fa-heading" },
    { "value": "fas fa-headphones-alt" },
    { "value": "fas fa-headphones" },
    { "value": "fas fa-headset" },
    { "value": "fas fa-heart-broken" },
    { "value": "fas fa-heart" },
    { "value": "fas fa-heartbeat" },
    { "value": "fas fa-helicopter" },
    { "value": "fas fa-highlighter" },
    { "value": "fas fa-hiking" },
    { "value": "fas fa-hippo" },
    { "value": "fas fa-history" },
    { "value": "fas fa-hockey-puck" },
    { "value": "fas fa-holly-berry" },
    { "value": "fas fa-home" },
    { "value": "fas fa-horse-head" },
    { "value": "fas fa-horse" },
    { "value": "fas fa-hospital-alt" },
    { "value": "fas fa-hospital-symbol" },
    { "value": "fas fa-hospital" },
    { "value": "fas fa-hot-tub" },
    { "value": "fas fa-hotdog" },
    { "value": "fas fa-hotel" },
    { "value": "fas fa-hourglass-end" },
    { "value": "fas fa-hourglass-half" },
    { "value": "fas fa-hourglass-start" },
    { "value": "fas fa-hourglass" },
    { "value": "fas fa-house-damage" },
    { "value": "fas fa-hryvnia" },
    { "value": "fas fa-i-cursor" },
    { "value": "fas fa-ice-cream" },
    { "value": "fas fa-icicles" },
    { "value": "fas fa-icons" },
    { "value": "fas fa-id-badge" },
    { "value": "fas fa-id-card-alt" },
    { "value": "fas fa-id-card" },
    { "value": "fas fa-igloo" },
    { "value": "fas fa-image" },
    { "value": "fas fa-images" },
    { "value": "fas fa-inbox" },
    { "value": "fas fa-indent" },
    { "value": "fas fa-industry" },
    { "value": "fas fa-infinity" },
    { "value": "fas fa-info-circle" },
    { "value": "fas fa-info" },
    { "value": "fas fa-italic" },
    { "value": "fas fa-jedi" },
    { "value": "fas fa-joint" },
    { "value": "fas fa-journal-whills" },
    { "value": "fas fa-kaaba" },
    { "value": "fas fa-key" },
    { "value": "fas fa-keyboard" },
    { "value": "fas fa-khanda" },
    { "value": "fas fa-kiss-beam" },
    { "value": "fas fa-kiss-wink-heart" },
    { "value": "fas fa-kiss" },
    { "value": "fas fa-kiwi-bird" },
    { "value": "fas fa-landmark" },
    { "value": "fas fa-language" },
    { "value": "fas fa-laptop-code" },
    { "value": "fas fa-laptop-medical" },
    { "value": "fas fa-laptop" },
    { "value": "fas fa-laugh-beam" },
    { "value": "fas fa-laugh-squint" },
    { "value": "fas fa-laugh-wink" },
    { "value": "fas fa-laugh" },
    { "value": "fas fa-layer-group" },
    { "value": "fas fa-leaf" },
    { "value": "fas fa-lemon" },
    { "value": "fas fa-less-than-equal" },
    { "value": "fas fa-less-than" },
    { "value": "fas fa-level-down-alt" },
    { "value": "fas fa-level-up-alt" },
    { "value": "fas fa-life-ring" },
    { "value": "fas fa-lightbulb" },
    { "value": "fas fa-link" },
    { "value": "fas fa-lira-sign" },
    { "value": "fas fa-list-alt" },
    { "value": "fas fa-list-ol" },
    { "value": "fas fa-list-ul" },
    { "value": "fas fa-list" },
    { "value": "fas fa-location-arrow" },
    { "value": "fas fa-lock-open" },
    { "value": "fas fa-lock" },
    { "value": "fas fa-long-arrow-alt-down" },
    { "value": "fas fa-long-arrow-alt-left" },
    { "value": "fas fa-long-arrow-alt-right" },
    { "value": "fas fa-long-arrow-alt-up" },
    { "value": "fas fa-low-vision" },
    { "value": "fas fa-luggage-cart" },
    { "value": "fas fa-magic" },
    { "value": "fas fa-magnet" },
    { "value": "fas fa-mail-bulk" },
    { "value": "fas fa-male" },
    { "value": "fas fa-map-marked-alt" },
    { "value": "fas fa-map-marked" },
    { "value": "fas fa-map-marker-alt" },
    { "value": "fas fa-map-marker" },
    { "value": "fas fa-map-pin" },
    { "value": "fas fa-map-signs" },
    { "value": "fas fa-map" },
    { "value": "fas fa-marker" },
    { "value": "fas fa-mars-double" },
    { "value": "fas fa-mars-stroke-h" },
    { "value": "fas fa-mars-stroke-v" },
    { "value": "fas fa-mars-stroke" },
    { "value": "fas fa-mars" },
    { "value": "fas fa-mask" },
    { "value": "fas fa-medal" },
    { "value": "fas fa-medkit" },
    { "value": "fas fa-meh-blank" },
    { "value": "fas fa-meh-rolling-eyes" },
    { "value": "fas fa-meh" },
    { "value": "fas fa-memory" },
    { "value": "fas fa-menorah" },
    { "value": "fas fa-mercury" },
    { "value": "fas fa-meteor" },
    { "value": "fas fa-microchip" },
    { "value": "fas fa-microphone-alt-slash" },
    { "value": "fas fa-microphone-alt" },
    { "value": "fas fa-microphone-slash" },
    { "value": "fas fa-microphone" },
    { "value": "fas fa-microscope" },
    { "value": "fas fa-minus-circle" },
    { "value": "fas fa-minus-square" },
    { "value": "fas fa-minus" },
    { "value": "fas fa-mitten" },
    { "value": "fas fa-mobile-alt" },
    { "value": "fas fa-mobile" },
    { "value": "fas fa-money-bill-alt" },
    { "value": "fas fa-money-bill-wave-alt" },
    { "value": "fas fa-money-bill-wave" },
    { "value": "fas fa-money-bill" },
    { "value": "fas fa-money-check-alt" },
    { "value": "fas fa-money-check" },
    { "value": "fas fa-monument" },
    { "value": "fas fa-moon" },
    { "value": "fas fa-mortar-pestle" },
    { "value": "fas fa-mosque" },
    { "value": "fas fa-motorcycle" },
    { "value": "fas fa-mountain" },
    { "value": "fas fa-mouse-pointer" },
    { "value": "fas fa-mug-hot" },
    { "value": "fas fa-music" },
    { "value": "fas fa-network-wired" },
    { "value": "fas fa-neuter" },
    { "value": "fas fa-newspaper" },
    { "value": "fas fa-not-equal" },
    { "value": "fas fa-notes-medical" },
    { "value": "fas fa-object-group" },
    { "value": "fas fa-object-ungroup" },
    { "value": "fas fa-oil-can" },
    { "value": "fas fa-om" },
    { "value": "fas fa-otter" },
    { "value": "fas fa-outdent" },
    { "value": "fas fa-pager" },
    { "value": "fas fa-paint-brush" },
    { "value": "fas fa-paint-roller" },
    { "value": "fas fa-palette" },
    { "value": "fas fa-pallet" },
    { "value": "fas fa-paper-plane" },
    { "value": "fas fa-paperclip" },
    { "value": "fas fa-parachute-box" },
    { "value": "fas fa-paragraph" },
    { "value": "fas fa-parking" },
    { "value": "fas fa-passport" },
    { "value": "fas fa-pastafarianism" },
    { "value": "fas fa-paste" },
    { "value": "fas fa-pause-circle" },
    { "value": "fas fa-pause" },
    { "value": "fas fa-paw" },
    { "value": "fas fa-peace" },
    { "value": "fas fa-pen-alt" },
    { "value": "fas fa-pen-fancy" },
    { "value": "fas fa-pen-nib" },
    { "value": "fas fa-pen-square" },
    { "value": "fas fa-pen" },
    { "value": "fas fa-pencil-alt" },
    { "value": "fas fa-pencil-ruler" },
    { "value": "fas fa-people-carry" },
    { "value": "fas fa-pepper-hot" },
    { "value": "fas fa-percent" },
    { "value": "fas fa-percentage" },
    { "value": "fas fa-person-booth" },
    { "value": "fas fa-phone-alt" },
    { "value": "fas fa-phone-slash" },
    { "value": "fas fa-phone-square-alt" },
    { "value": "fas fa-phone-square" },
    { "value": "fas fa-phone-volume" },
    { "value": "fas fa-phone" },
    { "value": "fas fa-photo-video" },
    { "value": "fas fa-piggy-bank" },
    { "value": "fas fa-pills" },
    { "value": "fas fa-pizza-slice" },
    { "value": "fas fa-place-of-worship" },
    { "value": "fas fa-plane-arrival" },
    { "value": "fas fa-plane-departure" },
    { "value": "fas fa-plane" },
    { "value": "fas fa-play-circle" },
    { "value": "fas fa-play" },
    { "value": "fas fa-plug" },
    { "value": "fas fa-plus-circle" },
    { "value": "fas fa-plus-square" },
    { "value": "fas fa-plus" },
    { "value": "fas fa-podcast" },
    { "value": "fas fa-poll-h" },
    { "value": "fas fa-poll" },
    { "value": "fas fa-poo-storm" },
    { "value": "fas fa-poo" },
    { "value": "fas fa-poop" },
    { "value": "fas fa-portrait" },
    { "value": "fas fa-pound-sign" },
    { "value": "fas fa-power-off" },
    { "value": "fas fa-pray" },
    { "value": "fas fa-praying-hands" },
    { "value": "fas fa-prescription-bottle-alt" },
    { "value": "fas fa-prescription-bottle" },
    { "value": "fas fa-prescription" },
    { "value": "fas fa-print" },
    { "value": "fas fa-procedures" },
    { "value": "fas fa-project-diagram" },
    { "value": "fas fa-puzzle-piece" },
    { "value": "fas fa-qrcode" },
    { "value": "fas fa-question-circle" },
    { "value": "fas fa-question" },
    { "value": "fas fa-quidditch" },
    { "value": "fas fa-quote-left" },
    { "value": "fas fa-quote-right" },
    { "value": "fas fa-quran" },
    { "value": "fas fa-radiation-alt" },
    { "value": "fas fa-radiation" },
    { "value": "fas fa-rainbow" },
    { "value": "fas fa-random" },
    { "value": "fas fa-receipt" },
    { "value": "fas fa-recycle" },
    { "value": "fas fa-redo-alt" },
    { "value": "fas fa-redo" },
    { "value": "fas fa-registered" },
    { "value": "fas fa-remove-format" },
    { "value": "fas fa-reply-all" },
    { "value": "fas fa-reply" },
    { "value": "fas fa-republican" },
    { "value": "fas fa-restroom" },
    { "value": "fas fa-retweet" },
    { "value": "fas fa-ribbon" },
    { "value": "fas fa-ring" },
    { "value": "fas fa-road" },
    { "value": "fas fa-robot" },
    { "value": "fas fa-rocket" },
    { "value": "fas fa-route" },
    { "value": "fas fa-rss-square" },
    { "value": "fas fa-rss" },
    { "value": "fas fa-ruble-sign" },
    { "value": "fas fa-ruler-combined" },
    { "value": "fas fa-ruler-horizontal" },
    { "value": "fas fa-ruler-vertical" },
    { "value": "fas fa-ruler" },
    { "value": "fas fa-running" },
    { "value": "fas fa-rupee-sign" },
    { "value": "fas fa-sad-cry" },
    { "value": "fas fa-sad-tear" },
    { "value": "fas fa-satellite-dish" },
    { "value": "fas fa-satellite" },
    { "value": "fas fa-save" },
    { "value": "fas fa-school" },
    { "value": "fas fa-screwdriver" },
    { "value": "fas fa-scroll" },
    { "value": "fas fa-sd-card" },
    { "value": "fas fa-search-dollar" },
    { "value": "fas fa-search-location" },
    { "value": "fas fa-search-minus" },
    { "value": "fas fa-search-plus" },
    { "value": "fas fa-search" },
    { "value": "fas fa-seedling" },
    { "value": "fas fa-server" },
    { "value": "fas fa-shapes" },
    { "value": "fas fa-share-alt-square" },
    { "value": "fas fa-share-alt" },
    { "value": "fas fa-share-square" },
    { "value": "fas fa-share" },
    { "value": "fas fa-shekel-sign" },
    { "value": "fas fa-shield-alt" },
    { "value": "fas fa-ship" },
    { "value": "fas fa-shipping-fast" },
    { "value": "fas fa-shoe-prints" },
    { "value": "fas fa-shopping-bag" },
    { "value": "fas fa-shopping-basket" },
    { "value": "fas fa-shopping-cart" },
    { "value": "fas fa-shower" },
    { "value": "fas fa-shuttle-van" },
    { "value": "fas fa-sign-in-alt" },
    { "value": "fas fa-sign-language" },
    { "value": "fas fa-sign-out-alt" },
    { "value": "fas fa-sign" },
    { "value": "fas fa-signal" },
    { "value": "fas fa-signature" },
    { "value": "fas fa-sim-card" },
    { "value": "fas fa-sitemap" },
    { "value": "fas fa-skating" },
    { "value": "fas fa-skiing-nordic" },
    { "value": "fas fa-skiing" },
    { "value": "fas fa-skull-crossbones" },
    { "value": "fas fa-skull" },
    { "value": "fas fa-slash" },
    { "value": "fas fa-sleigh" },
    { "value": "fas fa-sliders-h" },
    { "value": "fas fa-smile-beam" },
    { "value": "fas fa-smile-wink" },
    { "value": "fas fa-smile" },
    { "value": "fas fa-smog" },
    { "value": "fas fa-smoking-ban" },
    { "value": "fas fa-smoking" },
    { "value": "fas fa-sms" },
    { "value": "fas fa-snowboarding" },
    { "value": "fas fa-snowflake" },
    { "value": "fas fa-snowman" },
    { "value": "fas fa-snowplow" },
    { "value": "fas fa-socks" },
    { "value": "fas fa-solar-panel" },
    { "value": "fas fa-sort-alpha-down-alt" },
    { "value": "fas fa-sort-alpha-down" },
    { "value": "fas fa-sort-alpha-up-alt" },
    { "value": "fas fa-sort-alpha-up" },
    { "value": "fas fa-sort-amount-down-alt" },
    { "value": "fas fa-sort-amount-down" },
    { "value": "fas fa-sort-amount-up-alt" },
    { "value": "fas fa-sort-amount-up" },
    { "value": "fas fa-sort-down" },
    { "value": "fas fa-sort-numeric-down-alt" },
    { "value": "fas fa-sort-numeric-down" },
    { "value": "fas fa-sort-numeric-up-alt" },
    { "value": "fas fa-sort-numeric-up" },
    { "value": "fas fa-sort-up" },
    { "value": "fas fa-sort" },
    { "value": "fas fa-spa" },
    { "value": "fas fa-space-shuttle" },
    { "value": "fas fa-spell-check" },
    { "value": "fas fa-spider" },
    { "value": "fas fa-spinner" },
    { "value": "fas fa-splotch" },
    { "value": "fas fa-spray-can" },
    { "value": "fas fa-square-full" },
    { "value": "fas fa-square-root-alt" },
    { "value": "fas fa-square" },
    { "value": "fas fa-stamp" },
    { "value": "fas fa-star-and-crescent" },
    { "value": "fas fa-star-half-alt" },
    { "value": "fas fa-star-half" },
    { "value": "fas fa-star-of-david" },
    { "value": "fas fa-star-of-life" },
    { "value": "fas fa-star" },
    { "value": "fas fa-step-backward" },
    { "value": "fas fa-step-forward" },
    { "value": "fas fa-stethoscope" },
    { "value": "fas fa-sticky-note" },
    { "value": "fas fa-stop-circle" },
    { "value": "fas fa-stop" },
    { "value": "fas fa-stopwatch" },
    { "value": "fas fa-store-alt" },
    { "value": "fas fa-store" },
    { "value": "fas fa-stream" },
    { "value": "fas fa-street-view" },
    { "value": "fas fa-strikethrough" },
    { "value": "fas fa-stroopwafel" },
    { "value": "fas fa-subscript" },
    { "value": "fas fa-subway" },
    { "value": "fas fa-suitcase-rolling" },
    { "value": "fas fa-suitcase" },
    { "value": "fas fa-sun" },
    { "value": "fas fa-superscript" },
    { "value": "fas fa-surprise" },
    { "value": "fas fa-swatchbook" },
    { "value": "fas fa-swimmer" },
    { "value": "fas fa-swimming-pool" },
    { "value": "fas fa-synagogue" },
    { "value": "fas fa-sync-alt" },
    { "value": "fas fa-sync" },
    { "value": "fas fa-syringe" },
    { "value": "fas fa-table-tennis" },
    { "value": "fas fa-table" },
    { "value": "fas fa-tablet-alt" },
    { "value": "fas fa-tablet" },
    { "value": "fas fa-tablets" },
    { "value": "fas fa-tachometer-alt" },
    { "value": "fas fa-tag" },
    { "value": "fas fa-tags" },
    { "value": "fas fa-tape" },
    { "value": "fas fa-tasks" },
    { "value": "fas fa-taxi" },
    { "value": "fas fa-teeth-open" },
    { "value": "fas fa-teeth" },
    { "value": "fas fa-temperature-high" },
    { "value": "fas fa-temperature-low" },
    { "value": "fas fa-tenge" },
    { "value": "fas fa-terminal" },
    { "value": "fas fa-text-height" },
    { "value": "fas fa-text-width" },
    { "value": "fas fa-th-large" },
    { "value": "fas fa-th-list" },
    { "value": "fas fa-th" },
    { "value": "fas fa-theater-masks" },
    { "value": "fas fa-thermometer-empty" },
    { "value": "fas fa-thermometer-full" },
    { "value": "fas fa-thermometer-half" },
    { "value": "fas fa-thermometer-quarter" },
    { "value": "fas fa-thermometer-three-quarters" },
    { "value": "fas fa-thermometer" },
    { "value": "fas fa-thumbs-down" },
    { "value": "fas fa-thumbs-up" },
    { "value": "fas fa-thumbtack" },
    { "value": "fas fa-ticket-alt" },
    { "value": "fas fa-times-circle" },
    { "value": "fas fa-times" },
    { "value": "fas fa-tint-slash" },
    { "value": "fas fa-tint" },
    { "value": "fas fa-tired" },
    { "value": "fas fa-toggle-off" },
    { "value": "fas fa-toggle-on" },
    { "value": "fas fa-toilet-paper" },
    { "value": "fas fa-toilet" },
    { "value": "fas fa-toolbox" },
    { "value": "fas fa-tools" },
    { "value": "fas fa-tooth" },
    { "value": "fas fa-torah" },
    { "value": "fas fa-torii-gate" },
    { "value": "fas fa-tractor" },
    { "value": "fas fa-trademark" },
    { "value": "fas fa-traffic-light" },
    { "value": "fas fa-train" },
    { "value": "fas fa-tram" },
    { "value": "fas fa-transgender-alt" },
    { "value": "fas fa-transgender" },
    { "value": "fas fa-trash-alt" },
    { "value": "fas fa-trash-restore-alt" },
    { "value": "fas fa-trash-restore" },
    { "value": "fas fa-trash" },
    { "value": "fas fa-tree" },
    { "value": "fas fa-trophy" },
    { "value": "fas fa-truck-loading" },
    { "value": "fas fa-truck-monster" },
    { "value": "fas fa-truck-moving" },
    { "value": "fas fa-truck-pickup" },
    { "value": "fas fa-truck" },
    { "value": "fas fa-tshirt" },
    { "value": "fas fa-tty" },
    { "value": "fas fa-tv" },
    { "value": "fas fa-umbrella-beach" },
    { "value": "fas fa-umbrella" },
    { "value": "fas fa-underline" },
    { "value": "fas fa-undo-alt" },
    { "value": "fas fa-undo" },
    { "value": "fas fa-universal-access" },
    { "value": "fas fa-university" },
    { "value": "fas fa-unlink" },
    { "value": "fas fa-unlock-alt" },
    { "value": "fas fa-unlock" },
    { "value": "fas fa-upload" },
    { "value": "fas fa-user-alt-slash" },
    { "value": "fas fa-user-alt" },
    { "value": "fas fa-user-astronaut" },
    { "value": "fas fa-user-check" },
    { "value": "fas fa-user-circle" },
    { "value": "fas fa-user-clock" },
    { "value": "fas fa-user-cog" },
    { "value": "fas fa-user-edit" },
    { "value": "fas fa-user-friends" },
    { "value": "fas fa-user-graduate" },
    { "value": "fas fa-user-injured" },
    { "value": "fas fa-user-lock" },
    { "value": "fas fa-user-md" },
    { "value": "fas fa-user-minus" },
    { "value": "fas fa-user-ninja" },
    { "value": "fas fa-user-nurse" },
    { "value": "fas fa-user-plus" },
    { "value": "fas fa-user-secret" },
    { "value": "fas fa-user-shield" },
    { "value": "fas fa-user-slash" },
    { "value": "fas fa-user-tag" },
    { "value": "fas fa-user-tie" },
    { "value": "fas fa-user-times" },
    { "value": "fas fa-user" },
    { "value": "fas fa-users-cog" },
    { "value": "fas fa-users" },
    { "value": "fas fa-utensil-spoon" },
    { "value": "fas fa-utensils" },
    { "value": "fas fa-vector-square" },
    { "value": "fas fa-venus-double" },
    { "value": "fas fa-venus-mars" },
    { "value": "fas fa-venus" },
    { "value": "fas fa-vial" },
    { "value": "fas fa-vials" },
    { "value": "fas fa-video-slash" },
    { "value": "fas fa-video" },
    { "value": "fas fa-vihara" },
    { "value": "fas fa-voicemail" },
    { "value": "fas fa-volleyball-ball" },
    { "value": "fas fa-volume-down" },
    { "value": "fas fa-volume-mute" },
    { "value": "fas fa-volume-off" },
    { "value": "fas fa-volume-up" },
    { "value": "fas fa-vote-yea" },
    { "value": "fas fa-vr-cardboard" },
    { "value": "fas fa-walking" },
    { "value": "fas fa-wallet" },
    { "value": "fas fa-warehouse" },
    { "value": "fas fa-water" },
    { "value": "fas fa-wave-square" },
    { "value": "fas fa-weight-hanging" },
    { "value": "fas fa-weight" },
    { "value": "fas fa-wheelchair" },
    { "value": "fas fa-wifi" },
    { "value": "fas fa-wind" },
    { "value": "fas fa-window-close" },
    { "value": "fas fa-window-maximize" },
    { "value": "fas fa-window-minimize" },
    { "value": "fas fa-window-restore" },
    { "value": "fas fa-wine-bottle" },
    { "value": "fas fa-wine-glass-alt" },
    { "value": "fas fa-wine-glass" },
    { "value": "fas fa-won-sign" },
    { "value": "fas fa-wrench" },
    { "value": "fas fa-x-ray" },
    { "value": "fas fa-yen-sign" },
    { "value": "fas fa-yin-yang" }
]
export const imageHover: any =
    [
        { "value": "none" },

        { "value": "img-zoom-in" },
        { "value": "img-zoom-out" },
        { "value": "img-rotate-right" },
        { "value": "img-rotate-left" },
  

    ];
